import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../../mensajes2';

import { Dimmer } from "../../spinner";

import { validaSoloNumero, formatMoneda, validaMonto, formatoMonto } from '../../../util/varios';
import Axios from 'axios';
import moment from 'moment';


export const ActualizarFechaVencimiento = (props) => {

    /*  variables de estados */
    let op = require('../../../modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [contar, setContar] = useState(0);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    const [desde, setDesde] = useState(0);
    const [operacion, setOperacion] = useState(0);
    const txtFechaVen = useRef();
    const txtAnio = useRef();
    const cmbMes = useRef();
    const txtDescripcionActi = useRef();
    const txtAnios = useRef();

    useEffect(() => {


        if (contar === 0) {
            // if (errorReg) {
            //     setActivate(false);
            //     let obj = JSON.parse(JSON.stringify(errorReg));

            //     setTitulo("Error");
            //     setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
            //     setMostrar(true);
            //     setContar(contar + 1);
            // }
        }



    });

    const procesarRegistro = () => {

        setActivate(true)
       
        let endpoint = `${op.conexion}/api/industria/actfechaven`;
        let body = {
            nanio: txtAnio.current.value,
            nmes: cmbMes.current.value,
            fecha: txtFechaVen.current.value,
            nomtabla: props.nombretab,
            operacion:props.operacion}
        
        console.log(body)
        
        Axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {

                console.log(response.data.length)
                setActivate(false)

                if(response.data.length !== 0){
                    setMensaje({ mostrar: true, titulo: "Información.", texto: response.data[0].mensaje, icono: "informacion" });

                } else {
                   
                        setMensaje({ mostrar: true, titulo: "Exito.", texto: "Proceso realizado de manera satisfactoria.", icono: "exito" });
    
    
                   
                }
              


                
             

               


            }

        }).catch(function (error) {

           /*  setMensaje({
                mostrar: true,
                titulo: "ERROR",
                texto: error.response.data.message,
                icono: "error",
            });
 */
        })

    }
    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };


    const handleCloseMensa = () => {
        setMostrar(false);
        if (desde === 3) {
            props.onHideAcepta();
        }
        setDesde(0);
    }


    const handleInputChange = (event) => {
        if (event.which === 13) {
            if (event.target.id === 'inputAnio') {
                cmbMes.current.focus();
            } else if (event.target.id === 'inputFechaVen') {
                if (txtFechaVen.current.value === "") {
                    setTitulo("Error");
                    setMsg("Fecha Invalida");
                    setMostrar(true);
                } else {
                    btnAcepta.current.focus();
                }

            }
        } else if (typeof (event.which) === 'undefined') {
            if (event.target.id === 'inputFechaVen') {
                if (txtFechaVen.current.value === "") {
                    setTitulo("Error");
                    setMsg("Fecha Invalida");
                    setMostrar(true);
                }

            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const handleInputNumChange = (event) => {
        //setActiveIndex(1);
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            if (event.which === 13) {
                if (event.target.id === 'inputAnio') {
                    cmbMes.current.focus();
                }
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };


    const onChangeValidar = () => {

        var sigue = true;

        if (txtAnio.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe suministrar el Año.');
            setMostrar(true);
            txtAnio.current.focus();
            sigue = false;

        } else if (txtFechaVen.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe suministrar la fecha de vencimiento.');
            setMostrar(true);
            txtFechaVen.current.focus();
            sigue = false;

        }

        if (sigue) {

            procesarRegistro();


        }

    };
    const cancelar = () => {
        setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
        })
        props.onHideCancela();
        
    }

    const cerrarModal = () => {
        setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
        })
        props.onHideCancela();
       

    }


    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            backgroundColor="black"
            keyboard={false}
            style={{ backgroundColor: '#000000a6' }}

            onShow={() => {
                setOperacion(props.operacion);
            }}

        >
            <Modal.Header className='azulGradiant'>
                {operacion === 1 ? 'Agregar Fecha de Vencimiento.' : operacion === 2 ? 'Editar Fecha de Vencimiento.' : operacion === 3 ? 'Eliminar Fecha de Vencimiento.' : 'Consultar Fecha de Vencimiento.'}
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
            <Mensaje
                    mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === "Exito."
                            ? cerrarModal()
                            : setMensaje({
                                mostrar: false,
                                titulo: "",
                                texto: "",
                                icono: "",
                            });
                    }}
                />
               
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div >
                    <div className="border border-primary rounded row col-md-12 mx-auto px-0 py-2" >
                        {/* <h2>Datos de la Fecha de Vencimiento</h2> */}



                        <div class="input-group input-group-sm mb-1 col-md-12">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Año:</span>
                            <input type="text" autocomplete="off" disabled={props.operacion === 1 ? false : true} style={{ textAlign: 'right' }} ref={txtAnio} className="form-control form-control-sm" id="inputAnio" defaultValue={props.fechaseleccionada ? props.fechaseleccionada.anio : props.anioactual} onKeyUp={handleInputNumChange} onBlur={handleInputNumChange} />

                        </div>
                        <div class="input-group input-group-sm mb-1 col-md-12">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Mes:</span>
                            <select name="" ref={cmbMes} disabled={props.operacion === 1 ? false : true} className="form-control form-control-sm" defaultValue={props.fechaseleccionada ? props.fechaseleccionada.mes : '1'}>
                                <option key="0" value="1">ENERO</option>
                                <option key="1" value="2">FEBRERO</option>
                                <option key="2" value="3">MARZO</option>
                                <option key="3" value="4">ABRIL</option>
                                <option key="4" value="5">MAYO</option>
                                <option key="5" value="6">JUNIO</option>
                                <option key="6" value="7">JULIO</option>
                                <option key="7" value="8">AGOSTO</option>
                                <option key="8" value="9">SEPTIEMBRE</option>
                                <option key="9" value="10">OCTUBRE</option>
                                <option key="10" value="11">NOVIEMBRE</option>
                                <option key="11" value="12">DICIEMBRE</option>
                            </select>
                        </div>


                        <div class="input-group input-group-sm mb-1 col-md-12">
                            <span class="input-group-text" id="inputGroup-sizing-sm">Fecha:</span>
                            <input type="date" ref={txtFechaVen} disabled={props.operacion === 3 ? true : false} className="form-control form-control-sm" id="inputFechaVen" defaultValue={props.fechaseleccionada ? moment.utc(props.fechaseleccionada.fechaven).format('YYYY-MM-DD') : props.fechasistema} onKeyUp={handleInputChange} />

                        </div>






                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-center' >
                <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-sm btn-success rounded-pill"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}